[
  {
    "id": "001_venetian_masquerade_1_headwear_a",
    "name_jp": "ベネチア風帽子",
    "name_en": "Hat",
    "tags": ["accessory", "001_venetian_masquerade", "slot_1"],
    "theme": "001_venetian_masquerade",
    "slot": 1,
    "max_tier": 3,
    "release_date": "2023-02-13T15:00:00.000Z"
  },
  {
    "id": "001_venetian_masquerade_2_eyewear_a",
    "name_jp": "ベネチア風アイマスク",
    "name_en": "Glasses",
    "tags": ["accessory", "001_venetian_masquerade", "slot_2"],
    "theme": "001_venetian_masquerade",
    "slot": 2,
    "max_tier": 3,
    "release_date": "2023-02-13T15:00:00.000Z"
  },
  {
    "id": "001_venetian_masquerade_3_facewear_a",
    "name_jp": "ベネチア風フェイスマスク",
    "name_en": "Mask",
    "tags": ["accessory", "001_venetian_masquerade", "slot_3"],
    "theme": "001_venetian_masquerade",
    "slot": 3,
    "max_tier": 3,
    "release_date": "2023-02-13T15:00:00.000Z"
  },
  {
    "id": "001_venetian_masquerade_4_neckwear_a",
    "name_jp": "ベネチア風胸飾り",
    "name_en": "Scarf",
    "tags": ["accessory", "001_venetian_masquerade", "slot_4"],
    "theme": "001_venetian_masquerade",
    "slot": 4,
    "max_tier": 3,
    "release_date": "2023-02-13T15:00:00.000Z"
  },
  {
    "id": "001_venetian_masquerade_5_backwear_a",
    "name_jp": "ベネチア風マント",
    "name_en": "Cape",
    "tags": ["accessory", "001_venetian_masquerade", "slot_5"],
    "theme": "001_venetian_masquerade",
    "slot": 5,
    "max_tier": 3,
    "release_date": "2023-02-13T15:00:00.000Z"
  },
  {
    "id": "002_disco_night_fever_1_headwear_a",
    "name_jp": "ディスコヅラ",
    "name_en": "Hat",
    "tags": ["accessory", "002_disco_night_fever", "slot_1"],
    "theme": "002_disco_night_fever",
    "slot": 1,
    "max_tier": 3,
    "release_date": "2023-02-13T15:00:00.000Z"
  },
  {
    "id": "002_disco_night_fever_2_eyewear_a",
    "name_jp": "ディスコメガネ",
    "name_en": "Glasses",
    "tags": ["accessory", "002_disco_night_fever", "slot_2"],
    "theme": "002_disco_night_fever",
    "slot": 2,
    "max_tier": 3,
    "release_date": "2023-02-13T15:00:00.000Z"
  },
  {
    "id": "002_disco_night_fever_3_facewear_a",
    "name_jp": "ディスコひげ",
    "name_en": "Mask",
    "tags": ["accessory", "002_disco_night_fever", "slot_3"],
    "theme": "002_disco_night_fever",
    "slot": 3,
    "max_tier": 3,
    "release_date": "2023-02-13T15:00:00.000Z"
  },
  {
    "id": "002_disco_night_fever_4_neckwear_a",
    "name_jp": "ディスコネックレス",
    "name_en": "Scarf",
    "tags": ["accessory", "002_disco_night_fever", "slot_4"],
    "theme": "002_disco_night_fever",
    "slot": 4,
    "max_tier": 3,
    "release_date": "2023-02-13T15:00:00.000Z"
  },
  {
    "id": "002_disco_night_fever_5_backwear_a",
    "name_jp": "ミラーボール",
    "name_en": "Cape",
    "tags": ["accessory", "002_disco_night_fever", "slot_5"],
    "theme": "002_disco_night_fever",
    "slot": 5,
    "max_tier": 3,
    "release_date": "2023-02-13T15:00:00.000Z"
  },
  {
    "id": "003_sweet_lolita_1_headwear_a",
    "name_jp": "ロリータカチューシャ",
    "name_en": "Hat",
    "tags": ["accessory", "003_sweet_lolita", "slot_1"],
    "theme": "003_sweet_lolita",
    "slot": 1,
    "max_tier": 3,
    "release_date": "2023-02-13T15:00:00.000Z"
  },
  {
    "id": "003_sweet_lolita_2_eyewear_a",
    "name_jp": "ロリータメイク",
    "name_en": "Glasses",
    "tags": ["accessory", "003_sweet_lolita", "slot_2"],
    "theme": "003_sweet_lolita",
    "slot": 2,
    "max_tier": 3,
    "release_date": "2023-02-13T15:00:00.000Z"
  },
  {
    "id": "003_sweet_lolita_3_facewear_a",
    "name_jp": "ロリータウィッグ",
    "name_en": "Mask",
    "tags": ["accessory", "003_sweet_lolita", "slot_3"],
    "theme": "003_sweet_lolita",
    "slot": 3,
    "max_tier": 3,
    "release_date": "2023-02-13T15:00:00.000Z"
  },
  {
    "id": "003_sweet_lolita_4_neckwear_a",
    "name_jp": "ロリータひらひら",
    "name_en": "Scarf",
    "tags": ["accessory", "003_sweet_lolita", "slot_4"],
    "theme": "003_sweet_lolita",
    "slot": 4,
    "max_tier": 3,
    "release_date": "2023-02-13T15:00:00.000Z"
  },
  {
    "id": "003_sweet_lolita_5_backwear_a",
    "name_jp": "ロリータフラワー",
    "name_en": "Cape",
    "tags": ["accessory", "003_sweet_lolita", "slot_5"],
    "theme": "003_sweet_lolita",
    "slot": 5,
    "max_tier": 3,
    "release_date": "2023-02-13T15:00:00.000Z"
  },
  {
    "id": "004_oiran_1_headwear_a",
    "name_jp": "花魁ヘア",
    "name_en": "Hat",
    "tags": ["accessory", "004_oiran", "slot_1"],
    "theme": "004_oiran",
    "slot": 1,
    "max_tier": 3,
    "release_date": "2023-02-13T15:00:00.000Z"
  },
  {
    "id": "004_oiran_2_eyewear_a",
    "name_jp": "花魁メイク",
    "name_en": "Glasses",
    "tags": ["accessory", "004_oiran", "slot_2"],
    "theme": "004_oiran",
    "slot": 2,
    "max_tier": 3,
    "release_date": "2023-02-13T15:00:00.000Z"
  },
  {
    "id": "004_oiran_3_facewear_a",
    "name_jp": "花魁キセル",
    "name_en": "Mask",
    "tags": ["accessory", "004_oiran", "slot_3"],
    "theme": "004_oiran",
    "slot": 3,
    "max_tier": 3,
    "release_date": "2023-02-13T15:00:00.000Z"
  },
  {
    "id": "004_oiran_4_neckwear_a",
    "name_jp": "花魁きもの",
    "name_en": "Scarf",
    "tags": ["accessory", "004_oiran", "slot_4"],
    "theme": "004_oiran",
    "slot": 4,
    "max_tier": 3,
    "release_date": "2023-02-13T15:00:00.000Z"
  },
  {
    "id": "004_oiran_5_backwear_a",
    "name_jp": "花魁傘",
    "name_en": "Cape",
    "tags": ["accessory", "004_oiran", "slot_5"],
    "theme": "004_oiran",
    "slot": 5,
    "max_tier": 3,
    "release_date": "2023-02-13T15:00:00.000Z"
  },
  {
    "id": "005_ancient_egyptian_king_1_headwear_a",
    "name_jp": "エジプト風ヘッドバンド",
    "name_en": "Hat",
    "tags": ["accessory", "005_ancient_egyptian_king", "slot_1"],
    "theme": "005_ancient_egyptian_king",
    "slot": 1,
    "max_tier": 3,
    "release_date": "2023-02-13T15:00:00.000Z"
  },
  {
    "id": "005_ancient_egyptian_king_2_eyewear_a",
    "name_jp": "エジプト風帽子",
    "name_en": "Glasses",
    "tags": ["accessory", "005_ancient_egyptian_king", "slot_2"],
    "theme": "005_ancient_egyptian_king",
    "slot": 2,
    "max_tier": 3,
    "release_date": "2023-02-13T15:00:00.000Z"
  },
  {
    "id": "005_ancient_egyptian_king_3_facewear_a",
    "name_jp": "エジプト風メイク",
    "name_en": "Mask",
    "tags": ["accessory", "005_ancient_egyptian_king", "slot_3"],
    "theme": "005_ancient_egyptian_king",
    "slot": 3,
    "max_tier": 3,
    "release_date": "2023-02-13T15:00:00.000Z"
  },
  {
    "id": "005_ancient_egyptian_king_4_neckwear_a",
    "name_jp": "エジプト風ネックレス",
    "name_en": "Scarf",
    "tags": ["accessory", "005_ancient_egyptian_king", "slot_4"],
    "theme": "005_ancient_egyptian_king",
    "slot": 4,
    "max_tier": 3,
    "release_date": "2023-02-13T15:00:00.000Z"
  },
  {
    "id": "005_ancient_egyptian_king_5_backwear_a",
    "name_jp": "ピラミッド",
    "name_en": "Cape",
    "tags": ["accessory", "005_ancient_egyptian_king", "slot_5"],
    "theme": "005_ancient_egyptian_king",
    "slot": 5,
    "max_tier": 3,
    "release_date": "2023-02-13T15:00:00.000Z"
  },
  {
    "id": "006_angel_1_headwear_a",
    "name_jp": "天使の輪",
    "name_en": "Hat",
    "tags": ["event_gacha_only", "accessory", "006_angel", "slot_1"],
    "theme": "006_angel",
    "slot": 1,
    "max_tier": 4,
    "release_date": "2023-02-13T15:00:00.000Z"
  },
  {
    "id": "006_angel_2_eyewear_a",
    "name_jp": "天使メガネ",
    "name_en": "Glasses",
    "tags": ["event_gacha_only", "accessory", "006_angel", "slot_2"],
    "theme": "006_angel",
    "slot": 2,
    "max_tier": 4,
    "release_date": "2023-02-13T15:00:00.000Z"
  },
  {
    "id": "006_angel_3_facewear_a",
    "name_jp": "天使の矢",
    "name_en": "Mask",
    "tags": ["event_gacha_only", "accessory", "006_angel", "slot_3"],
    "theme": "006_angel",
    "slot": 3,
    "max_tier": 4,
    "release_date": "2023-02-13T15:00:00.000Z"
  },
  {
    "id": "006_angel_4_neckwear_a",
    "name_jp": "天使の胸飾り",
    "name_en": "Scarf",
    "tags": ["event_gacha_only", "accessory", "006_angel", "slot_4"],
    "theme": "006_angel",
    "slot": 4,
    "max_tier": 4,
    "release_date": "2023-02-13T15:00:00.000Z"
  },
  {
    "id": "006_angel_5_backwear_a",
    "name_jp": "天使の羽根",
    "name_en": "Cape",
    "tags": ["event_gacha_only", "accessory", "006_angel", "slot_5"],
    "theme": "006_angel",
    "slot": 5,
    "max_tier": 4,
    "release_date": "2023-02-13T15:00:00.000Z"
  },
  {
    "id": "007_devil_1_headwear_a",
    "name_jp": "悪魔の帽子",
    "name_en": "Hat",
    "tags": ["no_gacha", "accessory", "007_devil", "slot_1"],
    "theme": "007_devil",
    "slot": 1,
    "max_tier": 4,
    "release_date": "2023-02-13T15:00:00.000Z"
  },
  {
    "id": "007_devil_2_eyewear_a",
    "name_jp": "悪魔メイク",
    "name_en": "Glasses",
    "tags": ["no_gacha", "accessory", "007_devil", "slot_2"],
    "theme": "007_devil",
    "slot": 2,
    "max_tier": 4,
    "release_date": "2023-02-13T15:00:00.000Z"
  },
  {
    "id": "007_devil_3_facewear_a",
    "name_jp": "悪魔のツノ",
    "name_en": "Mask",
    "tags": ["no_gacha", "accessory", "007_devil", "slot_3"],
    "theme": "007_devil",
    "slot": 3,
    "max_tier": 4,
    "release_date": "2023-02-13T15:00:00.000Z"
  },
  {
    "id": "007_devil_4_neckwear_a",
    "name_jp": "悪魔のネクタイ",
    "name_en": "Scarf",
    "tags": ["no_gacha", "accessory", "007_devil", "slot_4"],
    "theme": "007_devil",
    "slot": 4,
    "max_tier": 4,
    "release_date": "2023-02-13T15:00:00.000Z"
  },
  {
    "id": "007_devil_5_backwear_a",
    "name_jp": "悪魔の翼",
    "name_en": "Cape",
    "tags": ["no_gacha", "accessory", "007_devil", "slot_5"],
    "theme": "007_devil",
    "slot": 5,
    "max_tier": 4,
    "release_date": "2023-02-13T15:00:00.000Z"
  },
  {
    "id": "008_whiteday_1_headwear_a",
    "name_jp": "ホワイトデーハット",
    "name_en": "Hat",
    "tags": ["event_gacha_only", "accessory", "008_whiteday", "slot_1"],
    "theme": "008_whiteday",
    "slot": 1,
    "max_tier": 4,
    "release_date": "2023-03-07T15:00:00.000Z"
  },
  {
    "id": "008_whiteday_2_eyewear_a",
    "name_jp": "ホワイトデーメガネ",
    "name_en": "Glasses",
    "tags": ["event_gacha_only", "accessory", "008_whiteday", "slot_2"],
    "theme": "008_whiteday",
    "slot": 2,
    "max_tier": 4,
    "release_date": "2023-03-07T15:00:00.000Z"
  },
  {
    "id": "008_whiteday_3_facewear_a",
    "name_jp": "ホワイトデー花飾り",
    "name_en": "Mask",
    "tags": ["event_gacha_only", "accessory", "008_whiteday", "slot_3"],
    "theme": "008_whiteday",
    "slot": 3,
    "max_tier": 4,
    "release_date": "2023-03-07T15:00:00.000Z"
  },
  {
    "id": "008_whiteday_4_neckwear_a",
    "name_jp": "ホワイトデーリボン",
    "name_en": "Scarf",
    "tags": ["event_gacha_only", "accessory", "008_whiteday", "slot_4"],
    "theme": "008_whiteday",
    "slot": 4,
    "max_tier": 4,
    "release_date": "2023-03-07T15:00:00.000Z"
  },
  {
    "id": "008_whiteday_5_backwear_a",
    "name_jp": "ホワイトデーフリフリ",
    "name_en": "Cape",
    "tags": ["event_gacha_only", "accessory", "008_whiteday", "slot_5"],
    "theme": "008_whiteday",
    "slot": 5,
    "max_tier": 4,
    "release_date": "2023-03-07T15:00:00.000Z"
  }
]
